<script>
import {useMedicalCenterStore} from "@/stores/Medical/MedicalCenter.js"
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {onMounted, watch} from "vue";
import {useSecurityStore} from "@/stores/Security.js";
import axios from "axios";

export default {
    setup() {
        const {total, loading, filter} = useSharedData();

        const {priceFormat, transformFilterValues} = useSharedMethod();

        const {$i18n, $router} = useTools();

        const medicalCenterStore = useMedicalCenterStore();
        const securityStore = useSecurityStore();

        const headers = [
            {
                text: "...",
                align: "left",
                sortable: false,
                value: "action",
                width: "0%"
            },
            {
                text: $i18n.t("common.code"),
                align: "left",
                sortable: true,
                value: "code",
                width: "0%"
            },
            {
                text: $i18n.t("common.label"),
                align: "left",
                sortable: true,
                value: "name",
                width: "0%"
            },
            {
                text: $i18n.t("common.phone"),
                align: "left",
                sortable: true,
                value: "phone",
                width: "0%"
            },
            {
                text: $i18n.t("common.fax"),
                align: "left",
                sortable: true,
                value: "fax",
                width: "0%"
            },
            {
                text: $i18n.t("common.email"),
                align: "left",
                sortable: true,
                value: "email",
                width: "0%"
            },
            {
                text: $i18n.t("common.web_site"),
                align: "left",
                sortable: true,
                value: "webSite",
                width: "0%"
            },
            {
                text: $i18n.t("common.comment"),
                align: "left",
                sortable: true,
                value: "observation",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'medical_centers.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'medical_centers.delete', params: {id: item.id}})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/medicalCenters', {params: transformFilterValues(filter.value)}).then((response) => {
                medicalCenterStore.setMedicalCenters(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => findAll());

        watch(() => filter.value, () => {
            findAll();
        }, {deep: true, immediate: true});

        function view(item) {
            $router.push({name: 'medical_centers.view', params: {id: item.id}});
        }

        return {
            medicalCenterStore,
            securityStore,
            headers,
            actions,
            total,
            loading,
            filter,
            priceFormat,
            view,
            findAll,
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.medical_center')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="true"
                    @press="$router.push({ name: 'medical_centers.add' })"
                />
            </template>

            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="3">
                            <w-text-field
                                v-model="filter.name"
                                :label="$t('common.label')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="medicalCenterStore.medicalCenters"
                    :total="total"
                    :loading="loading"
                    sort-by="code"
                    @rowDbClick="view"
                >

                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                    <template v-slot:[`item.phone`]="{ item }">
                        <w-inline-text :text="item.phone"/>
                    </template>
                    <template v-slot:[`item.fax`]="{ item }">
                        <w-inline-text :text="item.fax"/>
                    </template>
                    <template v-slot:[`item.email`]="{ item }">
                        <w-inline-text :text="item.email"/>
                    </template>
                    <template v-slot:[`item.webSite`]="{ item }">
                        <w-inline-text :text="item.webSite"/>
                    </template>
                    <template v-slot:[`item.observation`]="{ item }">
                        <w-inline-text :text="item.observation"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>
